import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import productsData from '../../data/innerpages/product/products.json';
import ProductSearch from '../common/ProductSearch';

function Navbar2() {
  const [showMega, setShowMega] = useState(false);
  const [activeCat, setActiveCat] = useState(0);
  const [showMobileMega, setShowMobileMega] = useState(false);
  const [activeMobileCat, setActiveMobileCat] = useState(null);
  const timeoutRef = useRef(null);

  const toggleMobileMega = (e) => {
    e.preventDefault();
    setShowMobileMega(!showMobileMega);
  };

  const toggleMobileCat = (e, index) => {
    e.preventDefault();
    setActiveMobileCat(activeMobileCat === index ? null : index);
  };

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setShowMega(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowMega(false);
      setActiveCat(0);
    }, 200);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light inner-navbar-style1">
      <div className="container-fluid">
        <Link className="navbar-brand me-lg-5" to="/">
          <img
            src="/innerpages/assets/img/logo_dark.png"
            alt=""
            className="logo"
            loading="eager"
            decoding="async"
          />
        </Link>

        <div className="d-flex flex-column align-items-end d-lg-none">
           <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="mt-2" style={{ marginRight: '-10px' }}>
            <ProductSearch lightMode={true} />
          </div>
        </div>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>
            <li
              className="nav-item mega-menu-wrapper d-none d-lg-block"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link className="nav-link" to="#!" onClick={(e) => e.preventDefault()}>
                Products <i className="la la-angle-down" style={{ fontSize: '10px', marginLeft: '4px' }}></i>
              </Link>
              <div className={`mega-menu-dropdown ${showMega ? 'show' : ''}`}>
                <div className="mega-menu-inner">
                  <div className="mega-menu-categories">
                    <span className="mega-menu-heading">CATEGORIES</span>
                    {productsData.categories.map((cat, idx) => (
                      <div
                        key={cat.id}
                        className={`mega-menu-cat-item ${activeCat === idx ? 'active' : ''}`}
                        onMouseEnter={() => setActiveCat(idx)}
                      >
                        <span>{cat.name}</span>
                        <i className="la la-angle-right"></i>
                      </div>
                    ))}
                  </div>
                    <div className="mega-menu-products">
                      <span className="mega-menu-heading">SERIES</span>
                      <div className="mega-menu-products-grid">
                        {productsData.categories[activeCat]?.products.map((product, idx) => (
                          <Link 
                            key={idx} 
                            to={`/product/${productsData.categories[activeCat].id}/${product.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`} 
                            className="mega-menu-product-item text-decoration-none"
                            onClick={() => setShowMega(false)}
                          >
                            <span className="product-title">{product.title}</span>
                            <span className="product-subtitle">{product.subtitle}</span>
                          </Link>
                        ))}
                      </div>
                    </div>
                </div>
              </div>
            </li>
            <li className="nav-item d-lg-none">
              <div className="nav-link d-flex justify-content-between align-items-center">
                <Link to="#!" onClick={(e) => e.preventDefault()} className="text-decoration-none text-dark flex-grow-1">
                  Products
                </Link>
                <i 
                  className={`la ${showMobileMega ? 'la-minus' : 'la-plus'}`} 
                  style={{ fontSize: '13px', cursor: 'pointer', padding: '5px 10px' }} 
                  onClick={toggleMobileMega}
                ></i>
              </div>
              {showMobileMega && (
                <ul className="list-unstyled ps-3 pe-3 mb-0 pb-2">
                  {productsData.categories.map((cat, idx) => (
                    <li key={cat.id} className="mb-2">
                      <span
                        className="d-block text-dark fw-bold"
                        style={{ fontSize: '15px', cursor: 'pointer', padding: '5px 0' }}
                        onClick={(e) => toggleMobileCat(e, idx)}
                      >
                        {cat.name} <i className={`la ${activeMobileCat === idx ? 'la-angle-up' : 'la-angle-down'}`} style={{ fontSize: '12px', float: 'right', marginTop: '4px' }}></i>
                      </span>
                      {activeMobileCat === idx && (
                        <div className="mt-1 ps-3 mb-2 border-start border-secondary">
                          {cat.products.map((product, pIdx) => (
                            <div key={pIdx} className="mb-2">
                              <Link 
                                to={`/product/${cat.id}/${product.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`} 
                                className="d-block text-muted text-decoration-none" 
                                style={{ fontSize: '13px' }}
                              >
                                {product.title}
                              </Link>
                            </div>
                          ))}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
            <li className="nav-item d-lg-none">
              <Link className="nav-link" to="/collection"> Our Collection </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/portfolio">
                Portfolio
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/services">
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/collection">
                Our Collection
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                About Us
              </Link>
            </li>
          </ul>
          <div className="nav-side nav-side--stack ms-lg-5 d-none d-lg-flex">
            <Link
              to="/contact"
              className="butn hover-bg-black text-capitalize bg-orange1 rounded-pill text-white d-none d-lg-inline-block"
            >
              <span> Get In Touch </span>
            </Link>
            <div className="nav-search-below">
              <ProductSearch lightMode={true} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar2;
